import { render, staticRenderFns } from "./diagnoseSummary2v.vue?vue&type=template&id=1fa9b1b4&scoped=true&"
import script from "./diagnoseSummary2v.vue?vue&type=script&lang=js&"
export * from "./diagnoseSummary2v.vue?vue&type=script&lang=js&"
import style0 from "./diagnoseSummary2v.vue?vue&type=style&index=0&id=1fa9b1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa9b1b4",
  null
  
)

export default component.exports